import * as CubeTree from '../../../cubeTree/index';
import Move from '../../move/index';
import { updateCubeList } from '../../../update/updateCubeList';
import { runForceUpdate } from '../../../update/runForceUpdate';
import { updateEnd } from '../../../update/updateEnd';
import { updateAllShelfsClass } from '../../../update/updateAllShelfsClass';

class DragRunerBae {
    protected moveUpadte(moveTaskQueue: MoveTask): void {
        let physicsMoveUpdateList: CubeId[] = Move.physicsUpdateList(moveTaskQueue);
        let logicMoveUpdateList: CubeId[] = Move.logicUpdateList(moveTaskQueue, physicsMoveUpdateList);
        let updateList: CubeId[] = physicsMoveUpdateList.concat(logicMoveUpdateList);
        let forceUpdate: CubeId[] = Move.forceUpdateList(moveTaskQueue);

        updateCubeList(updateList);
        runForceUpdate(forceUpdate);
        updateEnd();
    }

    protected addSubUpdate(moveTaskQueue: MoveTask): void {
        let moveTask: LogicMoveTask = moveTaskQueue.logic[0];
        let toLayer: CubeId = CubeTree.findParentIdByCubeId(moveTask.to.parent);
        let updateList: CubeId[] = [];

        updateList.push(moveTask.from.parent);
        updateList.push(toLayer);
        updateCubeList(updateList);
        updateEnd();
    }

    protected shelfMoveUpdate() {
        updateAllShelfsClass();
        updateEnd();
    }

    protected isAddSubGoodsMoveTask(moveTask: MoveTask): boolean {
        let tasks: LogicMoveTask[] = moveTask.logic;

        for (let i = 0; i < tasks.length; i++) {
            let task: LogicMoveTask = tasks[i];

            if (this.isAddSubGoods(task.from.moveTarget, task.to.parent)) {
                return true;
            }
        }

        return false;
    }

    private isAddSubGoods(target: CubeId, to: CubeId): boolean {
        return CubeTree.isGoods(target) && CubeTree.isGoods(to);
    }
}

export default DragRunerBae;
